import { render, staticRenderFns } from "./footer_impressum_privacy.vue?vue&type=template&id=98aab97a&scoped=true"
import script from "./footer_impressum_privacy.vue?vue&type=script&lang=js"
export * from "./footer_impressum_privacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98aab97a",
  null
  
)

export default component.exports